/**
 * The Atlas mark: a load-bearing A-frame cut by a mint crossbar.
 *
 * Rendered inline rather than as an <img> so it is crisp at every size, needs
 * no network request, and can inherit colour. The geometry is the same source
 * used by scripts/build-brand.mjs to generate the favicon, app icons and social
 * card — change it there and here together.
 */
type AtlasMarkProps = {
  /** Rendered size in px. */
  size?: number
  /** `glyph` draws the bare A; `tile` sets it on the brand's ink square. */
  variant?: "glyph" | "tile"
  className?: string
  /** Decorative by default — the adjacent wordmark carries the name. */
  title?: string
}

const FRAME = "M226 84 L286 84 L452 428 L356 428 L256 214 L156 428 L60 428 Z"
const BAR = "M208 312 L304 312 L324 356 L188 356 Z"

export default function AtlasMark({ size = 24, variant = "glyph", className, title }: AtlasMarkProps) {
  const tile = variant === "tile"
  const scale = tile ? 0.78 : 1
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 512 512"
      className={className}
      role={title ? "img" : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      focusable="false"
    >
      {title ? <title>{title}</title> : null}
      {tile ? <rect width="512" height="512" rx="113" fill="#08090d" /> : null}
      <g transform={`translate(256 256) scale(${scale}) translate(-256 -256)`}>
        <path d={FRAME} fill="#f59e0b" />
        <path d={BAR} fill="#10b981" />
      </g>
    </svg>
  )
}
